<template>
  <el-row :gutter="12" id="intro">
    <el-card shadow="hover" id="introCard">
      <el-col :span="3" >
        <img class="rounded-circle img-thumbnail" src="../assets/head.png"/>
      </el-col>
      <el-col :span="8" :offset="1" align="left">
        <h4>阿金</h4>
        <p>无法融入社会的死肥宅……<br/>
          曾经是一名吉他手……<br/>
          后来又成为了一名程序员……</p>
          <a href="https://github.com/curatorjin" target="_blank">GitHub</a>
          <span class="col-4"></span>
          <a href="https://space.bilibili.com/2137919" target="_blank">Bilibili</a>
      </el-col>
    </el-card>
  </el-row>
</template>

<script>
export default {
  name: 'Intro'
}
</script>

<style scoped>
 #intro{
   margin-top: 20px;
 }
  #introCard{
    padding-top: 10px;
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue